import { useTranslation } from 'next-i18next'
import { NextPage } from 'next/types'

import Leaderboard from '~/Leaderboard/pages/Leaderboard.page'
import Metatags from '~/components/Metadata/Metatags'
import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'
import { GetProps } from '~/utils/pageWrapper/types'
import { usePageTitle } from '~/utils/tags'

const LeaderboardPage: NextPage = () => {
  const { t } = useTranslation('leaderboard')

  return (
    <div>
      <Metatags metaDescription={t('metaDescription')} noindex title={usePageTitle(t('title'))} />
      <DefaultLayout zeroPadding>
        <Leaderboard />
      </DefaultLayout>
    </div>
  )
}
const getProps: GetProps = () => () => ({
  props: {
    namespaces: ['leaderboard', 'settings', 'subscription', ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES],
  },
})

export const getStaticProps = getStaticPropsWrapper(getProps)

export default LeaderboardPage
